import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { FormFieldModel } from './form-field.model';
import { SocialLinkModel } from './link.model';

export class LinksListFieldModel implements FormFieldModel {
    property: string;
    list: SocialLinkModel[];
    fieldComponent?: Type<AbstractFormFieldComponent>;
    label?: string;
    description?: string;

    constructor(
        property: string,
        list: SocialLinkModel[],
        fieldComponent?: Type<AbstractFormFieldComponent>,
        label?: string,
        description?: string,
    ){
        this.property = property;
        this.fieldComponent = fieldComponent;
        this.label = label;
        this.description = description;
        this.list = list;
    }
}
